<template>
  <button :class="buttonClass" @click="buttonClicked" :disabled="disabled">
  <fa :icon="icon" class="button-icon-wrapped" style="margin-top:-2px;margin-right: 3px;" v-if="icon" />
  <span>
    {{ caption }}
  </span>
  </button>
</template>
<script>
export default {
  name: 'basic-button',
  props: ['caption', 'action', 'disabled', 'icon', 'color', 'short'],
  computed: {
    buttonClass () {
      const base = "btn"
      let out = base
      if (this.color) {
        out = `${out} ${base}-${this.color}`
      }
      if (this.short) {
        out = `${out} ${base}-short`
      }
      return out
    }
  },
  methods: {
    buttonClicked () {
      if (this.action) {
        this.action()
      }
    }
  }
}
</script>
